import { render, staticRenderFns } from "./DialogBlockUser.vue?vue&type=template&id=7760b50b"
import script from "./DialogBlockUser.vue?vue&type=script&lang=js"
export * from "./DialogBlockUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports